









































































import { defineComponent, computed, ref, reactive, Ref } from '@vue/composition-api'
import Icon from '@/components/icon.vue'
import clickoutside from '@/directives/clickoutside'
import { useToggle } from '@shared/use/use-toggle'
import { useI18n } from '@shared/use/use-i18n'
import i18nHandle from '@/locales'
import { UserInfoState } from '@/layout/types'
import { TranslateResult } from 'vue-i18n'
import { setUserExternalValue, logout } from '@/api/user'
import { flushFeToken } from '@/api/page'
import { HOSTS } from '@/constants/environment'
import { jumpToUrl } from '@/utils/jump-to-url/index'

interface ModuleItem {
  id: string
  title?: TranslateResult
  describe?: TranslateResult
  icon?: NodeRequire
  type: string
  visible: boolean
  disabled: boolean
  privilege: boolean
  handler?: (module: ModuleItem) => void
  badge?: Ref<boolean>
}

const person = () => {
  window.open(`${HOSTS.CMS}/account/information`, '_blank')
}

const enterprise = () => {
  window.open(HOSTS.ENTERPRISE, '_blank')
}

const useUpdateLog = () => {
  const hasUpdate = ref(false)

  const markAsReadLog = () => {
    setUserExternalValue({
      key: 'crm.update_log',
      value: false,
    })
    window.open('https://www.xiaoman.cn/zh-cn/about/upgrade.html', '_blank')
  }

  return {
    hasUpdate,
    markAsReadLog,
  }
}

const goActivityLog = () => {
  jumpToUrl(`${HOSTS.CRM_HOST}/discovery/history`)
}

const handleLogout = () => {
  flushFeToken().then(() => {
    logout({
      system_id: 'v5client',
    }).then((response: any) => {
      // 退出后设置再次登陆回到上一次访问的 url
      // data.return_url 为跳转登陆页的 url
      // return_url 参数为登陆完成后服务端跳转的路径
      location.href = response.data.return_url + '&return_url=' + location.href
    })
  })
}

const useModules = () => {
  const { hasUpdate, markAsReadLog } = useUpdateLog()

  const getModules: () => ModuleItem[] = () => {
    return [
      {
        id: 'me',
        title: i18nHandle.t('profile.user'),
        describe: i18nHandle.t('profile.userDesc'),
        icon: require('@/assets/images/profile-me.png'),
        type: 'module',
        visible: true,
        disabled: false,
        privilege: true,
        handler: person,
      },
      {
        id: 'e',
        title: i18nHandle.t('profile.enterprize'),
        describe: i18nHandle.t('profile.enterprizeDesc'),
        icon: require('@/assets/images/profile-e.png'),
        type: 'module',
        visible: true,
        disabled: false,
        privilege: true,
        handler: enterprise,
      },
      {
        id: 'separator1',
        type: 'separator',
        visible: true,
        disabled: false,
        privilege: true,
      },
      {
        id: 'update',
        title: i18nHandle.t('profile.update'),
        describe: i18nHandle.t('profile.updateDesc'),
        icon: require('@/assets/images/profile-update.png'),
        type: 'module',
        visible: true,
        disabled: false,
        privilege: true,
        badge: hasUpdate,
        handler: markAsReadLog,
      },
      {
        id: 'separator2',
        type: 'separator',
        visible: true,
        disabled: false,
        privilege: true,
      },
      {
        id: 'logout',
        title: i18nHandle.t('profile.logout'),
        describe: '',
        icon: require('@/assets/images/profile-logout.png'),
        type: 'module',
        visible: true,
        disabled: false,
        privilege: true,
        handler: handleLogout,
      },
    ]
  }

  const [visible, toggle] = useToggle()

  const active = ref('me')

  const syntheticModules = computed(() => {
    const modules: ModuleItem[] = getModules().filter((item) => item.visible)

    const head = modules.slice(0, 1)

    return modules.slice(1).reduce((result, current) => {
      if (current.type === 'separator' && result[result.length - 1].type === 'separator') {
        return result
      }
      return result.concat(current)
    }, head)
  })

  const activeModule = computed(() => syntheticModules.value.find((item) => item.id === active.value))

  const handleClick = (moduleItem: ModuleItem) => {
    if (moduleItem.disabled) {
      return
    }
    const currentModule = syntheticModules.value.find((item) => item.id === moduleItem.id) as ModuleItem
    toggle(false)
    currentModule.handler?.(moduleItem)
  }

  return {
    syntheticModules,
    activeModule,
    active,
    handleClick,
    visible,
    hasUpdate,
    toggleVisible: toggle,
  }
}

interface ProfileProps {
  userInfoState?: UserInfoState
  customTip: (item: ModuleItem) => void
}

export default defineComponent<ProfileProps>({
  components: {},
  directives: {
    clickoutside,
  },
  props: {
    userInfoState: {
      type: Object,
      required: true,
      default() {
        return {
          avatar: '',
          real_name: '',
          nickname: '',
          email: '',
        }
      },
    },
    customTip: {
      type: Function,
    },
  },
  setup(props) {
    const { active, syntheticModules, activeModule, handleClick, visible, hasUpdate, toggleVisible } = useModules()
    const { $t } = useI18n()
    const hidePanel = () => toggleVisible(false)

    const getTip = (item: ModuleItem) => {
      if (typeof props.customTip === 'function') {
        return props.customTip(item)
      }
      switch (item.id) {
        case 'recommend':
          return $t('profile.noRecommend')
        default:
          return item.privilege ? $t('profile.nonactivated') : $t('profile.noPermission')
      }
    }

    return {
      active,
      syntheticModules,
      activeModule,
      handleClick,
      visible,
      hasUpdate,
      hidePanel,
      toggleVisible,
      getTip,
    }
  },
})
